import Col from './col';
import Row from './row';
import OriginGrid from './grid';
import GridItem from './grid-item';
var Grid = OriginGrid;
Grid.Col = Col;
Grid.Row = Row;
Grid.GridItem = GridItem;
export default Grid;
